import { defineAsyncComponent } from 'vue';
import { mountVueComponent } from '@/components/mountVueComponents';

const addToCartEl = document.querySelector('.js-add-to-cart');

if (addToCartEl) {
  const addToCart = defineAsyncComponent(() => import('@/components/cart/AddToCart.vue'));
  mountVueComponent(addToCartEl, addToCart, 'AddToCart');
}
